module.exports = __webpack_public_path__ + "static/img/icon_matron1.7f302e93.png";